import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import Sidebar from 'assets/templates/sidebar/Sidebar';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import Currency from 'models/enums/Currency';
import { ContractRefundInvoiceAction, useContractRefundInvoiceProvider } from '../Sales.ContractRefundInvoice.Hooks';

export default function ContractRefundInvoiceInfo() {
  const { lang, translate } = getLocales();
  const { selected, pageRouter } = useContractRefundInvoiceProvider();

  if (!selected || pageRouter.params?.action !== ContractRefundInvoiceAction.INFO) return null;

  const dealerPaymentControl = selected.contractRefundDealerPaymentControl;

  return (
    <Sidebar
      onClose={() => pageRouter.updateParams({})}
      icon={<Icon class="fas-file-invoice-dollar" />}
      title={selected.number}
      content={
        <>
          <h3>{lang.info}</h3>
          <div>
            {lang.invoiceNumber}: <b>{selected.number ?? 'N/A'}</b>
          </div>
          <div>
            {lang.status}: <b>{selected.isCancelled ? lang.cancelled : lang.active}</b>
          </div>
          <div>
            {lang.createdAt}:{' '}
            <b>{selected.createdAtLocal ? localizeDate(selected.createdAtLocal, defaultDateTimeFormat) : 'N/A'}</b>
          </div>
          <div>
            {lang.createdBy}: <b>{selected.createdBy?.fullName ?? 'N/A'}</b>
          </div>

          <div>
            {lang.paymentMethod}: <b>{selected.paymentMethodCode ? translate(selected.paymentMethodCode) : 'N/A'}</b>
          </div>
          <div>
            {lang.dealer}: <b>{dealerPaymentControl?.contractRefundPayee?.dealer?.name ?? 'N/A'}</b>
          </div>
          <div>
            {lang.paymentRequestedAt}:{' '}
            <b>
              {selected.paymentRequestedAtUtc
                ? localizeDate(selected.paymentRequestedAtUtc, defaultDateTimeFormat)
                : 'N/A'}
            </b>
          </div>

          <h3>{lang.prices}</h3>
          <div>
            {lang.currency}: <b>{selected.currency ?? 'N/A'}</b>
          </div>
          <div>
            {lang.amount}:{' '}
            <b>
              <FormatValue value={`${(selected.totalAmountBeforeTax || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {selected.currency === Currency.CAD ? lang.gstHst : lang.tax}:{' '}
            <b>
              <FormatValue value={`${(selected.gstHstAmount || 0).toFixed(2)}$`} />
            </b>
          </div>
          {selected.currency === Currency.CAD && (
            <div>
              {lang.pst}:{' '}
              <b>
                <FormatValue value={`${(selected.provincialSalesTaxAmount || 0).toFixed(2)}$`} />
              </b>
            </div>
          )}
          <div>
            {lang.total}:{' '}
            <b>
              <FormatValue value={`${(selected.totalAmount || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {lang.remittance}:{' '}
            <b>
              {/*TODO: Remittance (after total): true/false; true if Invoice is collected for Remittance*/}
              N/A
            </b>
          </div>

          <h3>{lang.dealerPaymentControl}</h3>
          <div>
            {`${lang.refund} #`}: <b>{dealerPaymentControl?.contractRefund?.jobId ?? 'N/A'}</b>
          </div>
          <div>
            {lang.accountingItemType}:{' '}
            <b>
              {dealerPaymentControl?.accountingItemTypeCode
                ? translate(dealerPaymentControl.accountingItemTypeCode)
                : 'N/A'}
            </b>
          </div>
          <div>
            {lang.allocatedAmount}:{' '}
            <b>
              <FormatValue value={`${(dealerPaymentControl?.allocatedAmountCAD || 0).toFixed(2)}$`} />
            </b>
          </div>

          <h3>{lang.document}</h3>
          <LinkButton
            class={ThemeButtonCircle}
            url={selected.invoiceDocument?.url}
            media={<Icon class="fas-download" />}
            render={selected.invoiceDocument?.name ?? lang.missing}
            target="_blank"
            disabled={!selected.invoiceDocument?.url}
            htmlElementProps={{
              title: !selected.invoiceDocument?.url ? lang.missing : lang.download,
            }}
            active
          />
        </>
      }
    />
  );
}
